import React, { useEffect, useState } from 'react';
import { EnterpriseModal, ModalField, ModalPrimaryButton, ModalSecondaryButton } from '../layout/EnterpriseModal';
import { normalizeRequiredReason } from '../../utils/problemReason';

interface ProblemReasonModalProps {
  open: boolean;
  mode: 'close' | 'reopen';
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

const COPY = {
  close: {
    title: 'Motivo do encerramento',
    text: 'Este problema não possui contramedida concluída. Informe por que ele pode ser encerrado sem uma verificação de eficácia.',
  },
  reopen: {
    title: 'Motivo da reabertura',
    text: 'A reabertura é administrativa e exige um motivo.',
  },
} as const;

export const ProblemReasonModal: React.FC<ProblemReasonModalProps> = ({
  open,
  mode,
  onClose,
  onConfirm,
}) => {
  const [value, setValue] = useState('');
  const copy = COPY[mode];
  const reason = normalizeRequiredReason(value);

  useEffect(() => {
    if (open) setValue('');
  }, [open, mode]);

  return (
    <EnterpriseModal
      open={open}
      onClose={onClose}
      title={copy.title}
      footer={(
        <>
          <ModalSecondaryButton onClick={onClose}>Cancelar</ModalSecondaryButton>
          <ModalPrimaryButton
            disabled={!reason}
            onClick={() => {
              if (!reason) return;
              onConfirm(reason);
            }}
          >
            Confirmar motivo
          </ModalPrimaryButton>
        </>
      )}
    >
      <p className="text-[13px] text-slate-600 dark:text-slate-300">{copy.text}</p>
      <ModalField label="Motivo *">
        <textarea
          value={value}
          onChange={(event) => setValue(event.target.value)}
          rows={4}
          className="w-full resize-y rounded border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-900 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200"
        />
      </ModalField>
    </EnterpriseModal>
  );
};
